import { type FC } from 'react'
import { useSalesforceBasedCalendarSync } from './hooks'
import { CalendarSyncSettingsView } from '../CalendarSyncSettingsView'
import { type IntegrationServiceId } from '../../../../../common/integrations'

export interface CalendarSyncSettingsProps {
  serviceId: IntegrationServiceId
}

export const CalendarSyncSettings: FC<CalendarSyncSettingsProps> = ({ serviceId }) => {
  const { enabled, isSyncDisabled, isAccountFetching, isFetching, isSaving, save } = useSalesforceBasedCalendarSync(serviceId)

  return (
    <CalendarSyncSettingsView
      serviceId={serviceId}
      enabled={enabled}
      disabled={isSyncDisabled || isAccountFetching}
      isLoading={isFetching}
      isSaving={isSaving}
      onSave={(value) => save(value)}
    />
  )
}
